module.exports = __webpack_public_path__ + "img/img09.ff682428.png";